import { useEffect } from 'react';
import { OG_IMAGE, SITE_ORIGIN } from '@/constants/site';

const MARK = 'data-seo';

/** name/property 로 meta 를 찾아 내용만 갱신한다. 없으면 만들고 표시를 남긴다 */
function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    el.setAttribute(MARK, '');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    el.setAttribute(MARK, '');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * 라우트별 문서 메타 정보.
 *
 * SPA 라 크롤러·SNS 스크래퍼가 이 값을 못 읽을 수 있다. 정적 기본값은
 * index.html 에 그대로 남겨두고, 여기서는 전환 시점의 갱신만 담당한다.
 *
 * @param {object} props
 * @param {string} props.title      <title> 전문
 * @param {string} props.description meta description / og:description
 * @param {string} props.path        canonical 경로 (예: '/plan')
 * @param {string} [props.ogTitle]   og/twitter 용 제목 (없으면 title)
 */
export function Seo({ title, description, path, ogTitle }) {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    const socialTitle = ogTitle || title;

    document.title = title;
    setMeta('name', 'description', description);
    setCanonical(url);

    setMeta('property', 'og:url', url);
    setMeta('property', 'og:title', socialTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', OG_IMAGE);

    setMeta('name', 'twitter:title', socialTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', OG_IMAGE);
  }, [title, description, path, ogTitle]);

  return null;
}
